<template>
  <div>
    <h3>Lista de Contatos do Concedentes</h3>
    <div v-if="concedente_id">
      <b-overlay variant="light" opacity=".3" blur="2px" :show="is_loading">
        <b-card>
          <div class="d-flex mb-2">
            <div class="w-75 mr-auto">
              <b-input-group size="sm">
                <b-form-input
                  v-model="termo_pesquisa"
                  v-on:keydown.enter="loadData"
                  placeholder="Pesquisar"
                ></b-form-input>
                <b-input-group-append>
                  <b-button @click="loadData" variant="exitos">
                    Buscar
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </div>
            <div>
              <b-button
                size="sm"
                variant="exitos"
                v-if="$can('concedente_contato:create')"
                v-b-modal.modal-form-contato
              >
                <font-awesome-icon icon="plus" />
                Novo Contato
              </b-button>
            </div>
          </div>

          <b-table
            striped
            hover
            :items="concedentes_contatos"
            :fields="fields"
            :busy="isBusy"
            @sort-changed="sortingChanged"
            show-empty
            sort-icon-left
          >
            <template #cell(nome)="{ item }">
              {{ item.nome }}<br />
              <small class="text-muted">{{ item.funcao }}</small>
            </template>
            <template #cell(endereco)="{ item }">
              <CellEndereco :endereco="item.endereco" />
            </template>
            <template #cell(contatos)="{ item }">
              <CellContatos v-if="item.contatos" :contatos="item.contatos" />
            </template>
            <template #cell(actions)="{ item }">
              <Actions
                :item="item"
                :view_show="false"
                :view_edit="$can('concedente_contato:edit')"
                :view_delete="$can('concedente_contato:delete')"
                :edit_to="openEditInModal ? null : 'concedentes_contatos_edit'"
                @edit="edit_concedente_contato"
                @delete="deleteItem"
              />
            </template>

            <template #empty="{}">
              <h5 class="text-center">Nenhum item encontado</h5>
            </template>
          </b-table>
        </b-card>

        <div>
          <pagination-nav :pagination="pagination" @input="loadData()" />
        </div>
      </b-overlay>

      <b-modal
        id="modal-form-contato"
        ref="modal-form-contato"
        :title="titleModal"
        size="xl"
        scrollable
        cancel-title="Cancelar"
        ok-title="Salvar"
        ok-variant="exitos"
        @ok="saveContato"
        @hidden="closeModal"
      >
        <Form
          ref="form-concedente"
          @saved="savedContato"
          :concedente_contato_id="concedente_contato_id"
          class="form-concedente-contato-modal"
        />
      </b-modal>
    </div>
    <div v-else>
      <base-alert type="info" class="m-4 p-4 text-center">
        <span class="alert-inner--icon mr-2">
          <font-awesome-icon icon="fas fa-exclamation-triangle" />
        </span>
        <span class="alert-inner--text"
          ><strong>Atenção!</strong><br />
          Para visualizar e cadastrar Contatos de Concedente é necessário,
          primeiro salvar as informações!</span
        >
      </base-alert>
    </div>
  </div>
</template>

<script>
import Form from "../Components/Form.vue";
import { mapState, mapActions } from "vuex";
import mixins from "@/components/Table/mixins";

export default {
  components: { Form },
  mixins: [mixins],
  props: {
    concedente_id: {
      type: Number,
      default: 0,
    },
    openEditInModal: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    concedente_contato_id: null,
  }),
  computed: {
    ...mapState("concedentes_contatos", [
      "concedentes_contatos",
      "pagination",
      "is_loading",
    ]),
    fields() {
      return [
        { key: "nome", label: "Nome", sortable: true },
        { key: "endereco", label: "Endereço" },
        { key: "contatos", label: "Contatos" },
        { key: "actions", label: "", class: "cell-actions" },
      ];
    },
    titleModal() {
      if (!this.openEditInModal) {
        return "Cadastro de Contato do Concedente";
      }

      return !!this.concedente_contato_id
        ? "Editar Contato do Concedente"
        : "Cadastro de Contato do Concedente";
    },
  },
  methods: {
    ...mapActions("concedentes_contatos", ["ActionGetAll", "ActionDelete"]),
    async loadData() {
      if (!this.concedente_id) return;
      this.isBusy = true;
      try {
        await this.ActionGetAll({
          page: this.pagination.current_page,
          per_page: this.pagination.per_page,
          orderBy: this.sortBy,
          sortBy: this.sortDesc ? "desc" : "asc",
          concedente_id: this.concedente_id,
          q: this.termo_pesquisa,
        });
      } catch (error) {
        this.$notifications.addNotification({
          message: "Erro ao carregar dados da listagem",
          icon: "exclamation-triangle",
          type: "danger",
        });
      }
      this.isBusy = false;
    },
    async edit_concedente_contato(concedente_contato) {
      this.concedente_contato_id = concedente_contato.id;
      this.$refs["modal-form-contato"].show();
    },
    savedContato() {
      this.$refs["modal-form-contato"].hide();
      this.loadData();
    },
    saveContato(event) {
      event.preventDefault();
      this.$refs["form-concedente"].onSubmit(event);
    },
    closeModal() {
      this.concedente_contato_id = null;
      // Garante que o modal está realmente fechado antes de resetar
      if (this.$refs["modal-form-contato"]) {
        this.$refs["modal-form-contato"].hide();
      }
      if (this.$route.name !== "concedentes_edit") {
        this.$router.push({
          name: "concedentes_edit",
          params: { id: this.concedente_id },
        });
      }
    },
  },
  watch: {
    concedente_id: {
      deep: true,
      handler: function () {
        this.loadData();
      },
    },
  },
  async created() {
    // if (this.$route.query.page > 1) {
    //   this.page = this.$route.query.page;
    // }
  },
};
</script>

<style lang="scss">
.form-concedente-contato-modal {
  font-size: 0.9rem;

  .modal-body {
    padding: 1.5rem 1rem !important;
  }

  .col-form-label {
    padding-bottom: calc(0.5rem + 1px);
  }
}
</style>
